// /src/store/mediaManagment/types.ts

import { Media } from '../../dataTypes/mediaManagment/types';

export const FETCH_MEDIA_REQUEST = 'FETCH_MEDIA_REQUEST';
export const FETCH_MEDIA_SUCCESS = 'FETCH_MEDIA_SUCCESS';
export const FETCH_MEDIA_FAILURE = 'FETCH_MEDIA_FAILURE';

export const FETCH_MEDIA_BY_ID_REQUEST = 'FETCH_MEDIA_BY_ID_REQUEST';
export const FETCH_MEDIA_BY_ID_SUCCESS = 'FETCH_MEDIA_BY_ID_SUCCESS';
export const FETCH_MEDIA_BY_ID_FAILURE = 'FETCH_MEDIA_BY_ID_FAILURE';

export const FETCH_MEDIA_BY_TYPE_REQUEST = 'FETCH_MEDIA_BY_TYPE_REQUEST';
export const FETCH_MEDIA_BY_TYPE_SUCCESS = 'FETCH_MEDIA_BY_TYPE_SUCCESS';
export const FETCH_MEDIA_BY_TYPE_FAILURE = 'FETCH_MEDIA_BY_TYPE_FAILURE';

export interface MediaState {
  loading: boolean;
  medias: Map<number, Media>;
  error: string | null;
  lastFetchTimestamp: number;
  lastFetchParams: GetMediaListParams | null;
}

export const initialState: MediaState = {
  loading: false,
  medias: new Map(),
  error: null,
  lastFetchTimestamp: 0,
  lastFetchParams: null,
};

export interface GetMediaListParams {
  mediaType?: string;
}

export interface FetchMediaRequestAction {
  type: typeof FETCH_MEDIA_REQUEST;
  payload: GetMediaListParams;
}

export interface FetchMediaSuccessAction {
  type: typeof FETCH_MEDIA_SUCCESS;
  payload: {
    medias: Media[];
    lastFetchTimestamp: number;
    lastFetchParams: GetMediaListParams | null;
  };
}

export interface FetchMediaFailureAction {
  type: typeof FETCH_MEDIA_FAILURE;
  payload: string;
}

export interface FetchMediaByIdRequestAction {
  type: typeof FETCH_MEDIA_BY_ID_REQUEST;
}

export interface FetchMediaByIdSuccessAction {
  type: typeof FETCH_MEDIA_BY_ID_SUCCESS;
  payload: Media;
}

export interface FetchMediaByIdFailureAction {
  type: typeof FETCH_MEDIA_BY_ID_FAILURE;
  payload: string;
}

export interface FetchMediaByTypeRequestAction {
  type: typeof FETCH_MEDIA_BY_TYPE_REQUEST;
}

export interface FetchMediaByTypeSuccessAction {
  type: typeof FETCH_MEDIA_BY_TYPE_SUCCESS;
  payload: Media[];
}

export interface FetchMediaByTypeFailureAction {
  type: typeof FETCH_MEDIA_BY_TYPE_FAILURE;
  payload: string;
}

export type MediaActionTypes =
  | FetchMediaRequestAction
  | FetchMediaSuccessAction
  | FetchMediaFailureAction
  | FetchMediaByIdRequestAction
  | FetchMediaByIdSuccessAction
  | FetchMediaByIdFailureAction
  | FetchMediaByTypeRequestAction
  | FetchMediaByTypeSuccessAction
  | FetchMediaByTypeFailureAction;
